module.exports = __webpack_public_path__ + "25248a11d0307b27cd908450b5f9414b.png";